/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Careers_Whatwedo_Streaming2Inputs */

const ja_careers_whatwedo_streaming2 = /** @type {(inputs: Careers_Whatwedo_Streaming2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eスポーツ大会のライブ配信`)
};

const en_careers_whatwedo_streaming2 = /** @type {(inputs: Careers_Whatwedo_Streaming2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Streaming and Esports`)
};

/**
* | output |
* | --- |
* | "Streaming and Esports" |
*
* @param {Careers_Whatwedo_Streaming2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const careers_whatwedo_streaming2 = /** @type {((inputs?: Careers_Whatwedo_Streaming2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Careers_Whatwedo_Streaming2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_careers_whatwedo_streaming2(inputs)
	return en_careers_whatwedo_streaming2(inputs)
});
export { careers_whatwedo_streaming2 as "careers_whatWeDo_streaming" }